<!-- Divider -->
<div
    class="ioteq-horizontal-navigation-item-wrapper divider"
    [ngClass]="item.classes?.wrapper"></div>
